import type { NavigationSocial } from '../../../store/navigation/socialSingle';
import { LinkTarget } from '../../../types/link';

const mapIcons = (classes: string) => {
  if (classes?.includes('youtube')) {
    return 'youtube';
  }
  if (classes?.includes('linkedin')) {
    return 'linkedin';
  }
  if (classes?.includes('instagram')) {
    return 'instagram';
  }
  if (classes?.includes('xing')) {
    return 'xing';
  }
  if (classes?.includes('facebook')) {
    return 'facebook';
  }
  if (classes?.includes('x')) {
    return 'x';
  }
  if (classes?.includes('wechat')) {
    return 'wechat';
  }
  if (classes?.includes('weibo')) {
    return 'weibo';
  }
  if (classes?.includes('youku')) {
    return 'youku';
  }
  if (classes?.includes('tiktok')) {
    return 'tiktok';
  }
};

export const mapSocial = (items?: NavigationSocial['items']) => ({
  items: items?.map(({ label, url, _id, newWindow, icon }) => ({
    id: _id,
    target: newWindow ? LinkTarget.blank : LinkTarget.self,
    title: label,
    icon: icon && mapIcons(icon),
    url,
    label,
  })),
});
